import { jsx as _jsx } from "react/jsx-runtime";
import { Dialog_Confirmation } from '@app/styles';
// Tracks, per WorkHub tab, whether the in-map resolution-function accordion has unsaved changes.
// Kept per-tab (not a single global flag) so two open pathway tabs don't cross-warn each other.
const dirtyByTab = {};
export const setResolutionAccordionDirty = (tabId, dirty) => {
    if (dirty)
        dirtyByTab[tabId] = true;
    else
        delete dirtyByTab[tabId];
};
export const isResolutionAccordionDirty = (tabId) => !!dirtyByTab[tabId];
// Call before any action that would leave the accordion (toggle to view mode, select another
// state/transition, click the pathway title, "Back to map"). Resolves true when it's safe to proceed.
export const guardResolutionAccordionUnsaved = (tabId) => {
    if (!isResolutionAccordionDirty(tabId))
        return Promise.resolve(true);
    return new Promise(resolve => {
        Dialog_Confirmation.show({
            header: 'Unsaved Changes',
            content: () => _jsx("div", { children: "You have unsaved resolution function changes. Leave without saving?" }),
            buttons: [
                { label: 'Leave Without Saving', action: () => resolve(true) },
                { label: 'Stay', isPreferred: true, action: () => resolve(false) }
            ]
        });
    });
};
//# sourceMappingURL=resolution-accordion-guard.js.map